import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { IonicPage, NavController, NavParams } from 'ionic-angular';
//import { ProviderBioPage, SchedulePage} from '../pages';
 import {ProviderBioDetailPage} from '../components/provider/provider-bio-detail.component';
//come here from:  exam-reason-for-exam.ts     visit purpose - reason for visit
@Component({
    selector: 'provider-detail-page',
    templateUrl: './provider-detail.html'
  })

export class ProviderDetailPage {
    patientId: number;

  constructor( private route: ActivatedRoute, private router: Router   ) {  
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
  }

 

}
